import React from 'react';
import P from 'prop-types';
import { useField , Field} from 'formik';
import FieldContainer from './Misc/FieldContainer';

const InputField = (props) => {
  const { label, name, placeholder, disabled, type, emailError, onBlur} = props;
  const [field, meta, form] = useField(name);
  const { touched, error } = meta;

  return (
    <div className="form-group">
    
      {/* <label className="col-lg-3 col-form-label" htmlFor={name}> */}
      <label  htmlFor={name}>
        {label}
      </label>
      {/* <FieldContainer errorMessage={touched && error && error}> */}
      <FieldContainer errorMessage={emailError ? 'البريد الالكتروني موجود بالفعل' : error} >
        <input
          {...field}
          id={name}
          placeholder={placeholder}
          disabled={disabled}
          className="form-control"
          onBlur={onBlur}
          type={type}
        />
      </FieldContainer>
    </div> 
  
  );
};

InputField.propTypes = {
  name: P.string.isRequired,
  label: P.string,
  placeholder: P.string,
  disabled: P.bool,
  type: P.string
};

InputField.defaultProps = {
  disabled: false,
};

export default InputField;
